import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { StoreMembership, StoreMembershipsService } from 'src/app/core/store-memberships.service';
import { ERROR_SELLER_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-store-details-team-data',
  templateUrl: './store-details-team-data.component.html',
  styleUrls: ['./store-details-team-data.component.scss'],
})
export class StoreDetailsTeamDataComponent {
  @Input() company_id?: string | null;
  @Input() store_id?: string | null;
  sellers?: StoreMembership[];
  is_read_running = true;

  constructor(private store_membership_service: StoreMembershipsService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.sellers = [];
    if (this.store_id) this.listSellers(this.store_id);
  }

  onRefresh(): void {
    this.sellers = [];
    if (this.store_id) this.listSellers(this.store_id);
  }

  listSellers(store_id?: string): void {
    this.is_read_running = true;

    if (store_id) {
      this.store_membership_service.listStoreMembershipsByStoreId(store_id).subscribe({
        next: response => {
          this.sellers = response.data;
          this.is_read_running = false;
        },
        error: error => {
          this.error_service.processGenericApiError(error);
          this.is_read_running = false;
        },
      });
    }
  }
}
